import { ChangeDetectionStrategy, Component, Inject, Optional } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

interface DialogData {
  minDate?: Date;
  onSubmit?: (formValue: any) => void;
  [key: string]: any;
}

@Component({
  selector: 'lpa-excess-debit-dialog',
  templateUrl: './excess-debit-dialog.component.html',
  styleUrls: ['./excess-debit-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExcessDebitDialogComponent {
  form: FormGroup;
  minDateTime: string;
  
  constructor(
    @Optional() public dialogRef: MatDialogRef<ExcessDebitDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private fb: FormBuilder
  ) {
    // Set minimum date time for the input
    const minDate = this.data?.minDate || new Date();
    this.minDateTime = this.formatDateTimeForInput(minDate);
    
    // Initialize form with date starting from minDate
    this.form = this.fb.group({
      motif: ['', Validators.required],
      dateTime: [this.minDateTime, Validators.required]
    });
  }

  onCancel(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }

  onSubmit(): void {
    if (this.form.valid) {
      const formValue = {
        motif: this.form.value.motif,
        dateTime: this.form.value.dateTime
      };
      
      if (this.dialogRef) {
        if (this.data?.onSubmit) {
          this.data.onSubmit(formValue);
        }
        this.dialogRef.close(formValue);
      }
    } else {
      // Mark all fields as touched to show validation errors
      this.form.markAllAsTouched();
    }
  }

  // Helper method to check if a field has errors
  hasFieldError(fieldName: string): boolean {
    const field = this.form.get(fieldName);
    return !!(field && field.invalid && (field.dirty || field.touched));
  }

  // Helper method to get field error message
  getFieldError(fieldName: string): string {
    const field = this.form.get(fieldName);
    if (field?.errors?.['required']) {
      return 'Ce champ est obligatoire';
    }
    return '';
  }

  // Format date for datetime-local input (YYYY-MM-DDTHH:mm:ss)
  private formatDateTimeForInput(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
  }
}